/**
 * What a notification is about. One schema for the hosted platform (Web Push)
 * and the desktop client (native notifications), so both say the same thing
 * about the same event.
 */
export const NOTIFICATION_KINDS = [
    // What your own bots do.
    "position_opened",
    "trade_closed",
    "liquidation",
    "bot_stopped",
    "bot_crashed",
    "feed_gap",
    "bot_drawdown",
    "bot_profit",
    // Alerts you set up.
    "price_alert",
    "daily_summary",
    // The community.
    "social",
    "followed_bot",
    // For admins: something on the platform needs looking at.
    "ops_alert",
];
/** The kinds a bot's own process can produce: all that the desktop app, which has no server, can raise. */
export const BOT_EVENT_KINDS = [
    "position_opened",
    "trade_closed",
    "liquidation",
    "bot_stopped",
    "bot_crashed",
    "feed_gap",
];
/** How a settings screen groups the kinds. */
export const KIND_GROUPS = [
    { id: "bots", label: "My bots", kinds: [...BOT_EVENT_KINDS, "bot_drawdown", "bot_profit"] },
    { id: "alerts", label: "Alerts", kinds: ["price_alert", "daily_summary"] },
    { id: "community", label: "Community", kinds: ["social", "followed_bot"] },
    { id: "admin", label: "Admin", kinds: ["ops_alert"] },
];
/** Groups only admins see in their settings. */
export const ADMIN_KIND_GROUPS = ["admin"];
/** Worth waking a person for, even in their quiet hours (if they allow it). */
export const URGENT_KINDS = ["liquidation", "bot_crashed"];
//# sourceMappingURL=types.js.map